import React from "react";

type NPSProps = {
  companyName: string;
  setDescriptionText: React.Dispatch<React.SetStateAction<string | null>>;
  onSubmitNPS(score: number | null): void;
};

function NPS({ companyName, onSubmitNPS, setDescriptionText }: NPSProps) {
  const getLabelText = (value: number) => {
    const adjustedValue = value;
    switch (adjustedValue) {
      case 1:
        return "Extremely unlikely";
      case 2:
        return "Not likely at all";
      case 3:
      case 4:
        return "Not likely";
      case 5:
        return "Neutral";
      case 6:
      case 7:
        return "Likely";
      case 8:
      case 9:
        return "Very likely";
      case 10:
        return "Extremely likely";
      default:
        return "";
    }
  };

  return (
    <div className="space-y-3">
      <h3 className="text-h3">
        How likely are you to recommend interviewing at {companyName} to a
        friend or colleague?
      </h3>
      <div className="flex justify-center !my-5 w-full">
        <div className="flex flex-wrap justify-center">
          {Array.from({ length: 10 }, (_, i) => {
            const value = i + 1;

            return (
              <button
                key={i}
                className="mx-1 my-1 w-8 h-8 rounded-full border-[0.1rem] text-xs border-gray-200 text-subtle hover:bg-red-500 hover:text-white hover:border-none transition-colors"
                onClick={() => onSubmitNPS(value)}
                type="button"
                onMouseEnter={() => setDescriptionText(getLabelText(value))}
                onMouseLeave={() => setDescriptionText(null)}
              >
                {value}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default NPS;
